import React, { PropsWithChildren, useMemo } from 'react';
import cn from 'classnames';

import { Header, useKeyboardHeight } from '../../../../BaseComponents';

import ModalFullscreen from '../../../../ModalFullscreen';

import { EngineTheme, useMergeClasses, useTheme } from '../../../../theme';

type Props = {
	title: string;
	isOpen: boolean;
	onClose: () => void;
	onGoBackward?: React.DispatchWithoutAction;
	footer?: React.ReactElement;
	classes?: EngineTheme['Shared']['MobileDialog'];
	bgVariant?: 'white' | 'bg-fill';
	className?: string;
};

const MobileDialog: React.FC<PropsWithChildren<Props>> = ({
	title,
	isOpen,
	children,
	onClose,
	footer,
	classes,
	className,onGoBackward, bgVariant = 'white'
}) => {
	const { MobileDialog: defaultTheme } = useTheme('Shared');

	const keyboardHeight = useKeyboardHeight();

	const css = useMergeClasses(defaultTheme, classes);

	const modalFullscreenClasses = useMemo<EngineTheme['ModalFullscreen']['ModalFullscreen']>(
		() => ({
			paper: cn(classes?.paper, { [css.bgFill]: bgVariant === 'bg-fill' }),
			root: classes?.root
		}),
		[bgVariant]
	);

	return (
		<ModalFullscreen
			keepMounted={false}
			isOpen={isOpen}
			ignoreClose
			classes={modalFullscreenClasses}
			className={cn(className, {
				[css.bgFill]: bgVariant === 'bg-fill'
			})}
		>
			<div className={cn(css.mobileDialog__dialog, classes?.mobileDialog__dialog)}>
				<Header
					className={cn(css.mobileDialog__header, classes?.mobileDialog__header)}
					onClose={onClose}
					onGoBackward={onGoBackward}
					equalSlotsBasis={false}
					showEmptySlots={false}
					left={<div className={cn(css.mobileDialog__title, classes?.mobileDialog__title)}>{title}</div>}
				/>

				<div className={css.content}>{children}</div>

				{footer && (
					<div
						className={cn(css.mobileDialog__footer, classes?.mobileDialog__footer)}
						style={{ bottom: keyboardHeight }}
					>
						{footer}
					</div>
				)}
			</div>
		</ModalFullscreen>
	);
};

export default MobileDialog;
